import styled from '@emotion/styled/macro';

export const LayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${props => props.theme.widths.containerMaxWidth};
    margin: 0 auto;
    height: 100%;

    @media (max-width: ${props => props.theme.widths.containerMaxWidth}) {
        max-width: 100%;
    }
`;

export const WelcomeMessage = styled.div`
    margin: ${props => `0  auto ${props.theme.spacing.large}`};
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
`;

export const Name = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    text-transform: capitalize;
`;

export const BannerImageWrapper = styled.div`
    height: 100px;
    overflow: hidden;
    position: relative;
    width: 100%;

    @media (max-width: ${props => props.theme.widths.mobileMax}) {
        aspect-ratio: 4 / 1;
        height: auto;
        overflow: unset;
    }
`;

export const BannerImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
`;

export const Footer = styled.div`
    text-align: center;
    max-width: ${props => props.theme.widths.containerMaxWidth};
    font-size: ${props => props.theme.fontSize.xsmall};
    padding: 16px;
`;
